import React, { useState,useRef} from "react";
import "./CustomRecurrencePopup.css";
import DatePicker from "react-datepicker";
import { Calendar as CalendarIcon } from "lucide-react";
import "react-datepicker/dist/react-datepicker.css";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next"; 
import CustomDropdown from "../Dropdown/CustomDropdown";
export default function CustomRecurrencePopup({ onClose, onSave,baseDate }) {
  const { t } = useTranslation();
  const [frequency, setFrequency] = useState(1);
  const [unit, setUnit] = useState("week");
  const [days, setDays] = useState([]);
  const [endType, setEndType] = useState("after");
  const [occurrences, setOccurrences] = useState(0);
  const [showCalendar, setShowCalendar] = useState(false);
  const [monthOption, setMonthOption] = useState("dayNumber");
  const calendarRef = useRef(null);
  const [error, setError] = useState("");
  const initialBaseDate = baseDate ? new Date(baseDate) : new Date();
  const [endDate, setEndDate] = useState(initialBaseDate);

  const toggleDay = (day) => {
    setDays((prev) =>
      prev.includes(day) ? prev.filter((d) => d !== day) : [...prev, day]
    );
  };

  const handleSave = () => {
  if (endType === "after" && (!occurrences || occurrences <= 0)) {
      setError(t("error_invalid_occurrences"));
      return;
    }

  setError("");

    const recurrenceData = {
      recurrence_frequency: frequency,
      recurrence_unit: unit,
      recurrence_days: unit === "week" ? days : [],
      recurrence_month_option: unit === "month" ? monthOption : null,
      recurrence_end_type: endType,
      recurrence_occurrences: endType === "after" ? occurrences : null,
      recurrence_end_date: endType === "onDate" ? endDate : null,
    };

    onSave(recurrenceData);
    onClose();
  };

  return (
   <div className="recurrence-popup">
  <div className="popup-content">
    <div className="popup-header">
      <h3>{t("customize")}</h3>
      <button className="close-btn" onClick={onClose}>×</button>
    </div>

    <div className="repeat-row">
      <span>{t("repeat_every")}</span>
      <div className="counter">
        <button onClick={() => setFrequency(frequency - 1)}>-</button>
        <span>{frequency}</span>
        <button onClick={() => setFrequency(frequency + 1)}>+</button>
      </div>
<CustomDropdown
    options={[
      { value: "day", label: t("days") },
      { value: "week", label: t("weeks") },
      { value: "month", label: t("months") },
      { value: "year", label: t("years") },
    ]}
    value={unit}
    onChange={setUnit}
    width="10rem"
  />
    </div>
    {unit === "week" && (
    <div className="days-section">
      <span>{t("repeat_on")}</span>
      <div className="days-row">
        {t("weekdays_short", { returnObjects: true }).map((label, i) => {
          const codes = ["MO", "TU", "WE", "TH", "FR", "SA", "SU"];
          return (
            <button
      key={label + i}
      className={`day-btn ${days.includes(codes[i]) ? "active" : ""}`}
      onClick={() => toggleDay(codes[i])}
    >
      {label}
    </button>
          );
        })}
      </div>
    </div>
        )}
        {unit === "month" && (
          <div className="month-option-section">
            <span>{t("repeat")}</span>
            <div className="month-option-row">
              <input
          type="text"
          readOnly
          value={`${t("every_month_on")} ${
baseDate ? new Date(baseDate).getDate() : new Date().getDate()
}`}
          className="month-option-input"
        />
              <ChevronDown size={18} className="unit-select-icon" />
            </div>
          </div>
        )}
        {unit === "year" && (
        <div className="month-option-section">
        <span>{t("repeat")}</span>
        <div className="month-option-row">
          <input
            type="text"
            readOnly
            value={`${t("every_year_on")} ${
              baseDate
                ? new Date(baseDate).toLocaleDateString("fr-FR", {
                    day: "numeric",
                    month: "long",
                  })
                : new Date().toLocaleDateString("fr-FR", {
                    day: "numeric",
                    month: "long",
                  })
            }`}
            className="month-option-input"
          />
          </div>
          </div>
        )}
    <div className="end-section">
  <span>{t("end")}</span>

  <div className="end-row">
     <input
        type="radio"
        checked={endType === "never"}
        onChange={() => setEndType("never")}
      />
    <label className="end-option">{t("never")}</label>
  </div>

  <div className="end-row">
            <input
              type="radio"
              checked={endType === "onDate"}
              onChange={() => setEndType("onDate")}
            />
            <label className="end-option">{t("on")}</label>

            <div className="datepicker-container" ref={calendarRef}>
              <DatePicker
                selected={endDate}
                onChange={(date) => {
                  setEndDate(date);
                  setShowCalendar(false);
                }}
                dateFormat="dd MMMM yyyy"
                minDate={new Date()}
                open={showCalendar}
                onClickOutside={() => setShowCalendar(false)}
                className="end-date-display"
                disabled={endType !== "onDate"}
              />
              <CalendarIcon
                size={18}
                className="calendar-icon-inside"
                onClick={(e) => {
                  e.stopPropagation();
                  if (endType === "onDate") setShowCalendar(!showCalendar);
                }}
              />
            </div>
          </div>

  <div className="end-row">
     <input
        type="radio"
        checked={endType === "after"}
        onChange={() => setEndType("after")}
      />
    <label className="end-option">{t("after")}</label>
    <div className="after-inline">
      <button
        className="counter-btn"
        onClick={() => setOccurrences(Math.max(0, occurrences - 1))}
      >
        -
      </button>
      <span>
<strong>{occurrences}</strong> {t("events")}
</span>
      <button
        className="counter-btn"
        onClick={() => setOccurrences(occurrences + 1)}
      >
        +
      </button>
    </div>
  </div>
</div>


    <div className="actions">
      <button className="cancel" onClick={onClose}>
{t("cancel")}
</button>
      <button
 className="validate"
  onClick={handleSave}
 disabled={endType === "after" && (!occurrences || occurrences <= 0)}
>
    {t("confirm")}
  </button>
</div>
{error && (
  <p
 style={{
    color: "red",
    fontSize: "0.875rem",
    marginTop: "0.625rem",
    textAlign: "center",
  }}
>
    {error}
  </p>
)}
  </div>
</div>

  );
}
